export const userConstants = {
  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  MAIN_LOGIN_SUCCESS: "MAIN_USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",
  MAIN_LOGIN_FAILURE: "MAIN_USERS_LOGIN_FAILURE",
  LOGOUT: "USERS_LOGOUT",
  GET_USER_INFO: "USERS_GET_USER_INFO",
  GET_GEO_LOCATION: "GET_GEO_LOCATION",
};
